import {
  ModalGallery,
  Wrapper,
  Body,
  Header,
  ControlWrapper,
  Controls,
  Footer,
  Gallery,
  GalleryImageContainer,
  GalleryImagesContainer,
  GalleryImages,
  Title,
  Image
} from './styles'

ModalGallery.Wrapper = Wrapper
ModalGallery.Body = Body
ModalGallery.Header = Header
ModalGallery.ControlWrapper = ControlWrapper
ModalGallery.Controls = Controls
ModalGallery.Footer = Footer
ModalGallery.Gallery = Gallery
ModalGallery.GalleryImageContainer = GalleryImageContainer
ModalGallery.GalleryImagesContainer = GalleryImagesContainer
ModalGallery.GalleryImages = GalleryImages
ModalGallery.Title = Title
ModalGallery.Image = Image

export default ModalGallery
